import { memo } from 'react';

import { Props } from '@/pages/Timeline/components/TimelineItemSubtitle/types';
import Heading from '@/ui/components/Heading/Heading';

const TimelineItemSubtitle = ({ text, sensitive = false }: Props) => {
  return (
    <Heading
      className={`${sensitive ? 'mp-sensitive ' : ''}font-normal text-gray-600`}
      text={text}
      value={4}
    />
  );
};

export default memo(TimelineItemSubtitle);
